import React from 'react';

const features = [
    {name: 'Conversations', description: "Manage conversations details", url: "/conversations"},
    {name: 'Affiliate clicks', description: "Manage affiliate clicks ", url: "/affiliate_clicks"},
    {name: 'Thesaurus', description: "Manage thesaurus for products", url: "/thesaurus"},
    {name: 'PSQ Management', description: "Manage product specific questions", url: "/psq"}
];

const AdminFeatures = () => {
    const handleRedirect = (url) => {
        const baseUrl = window.location.origin + window.location.pathname;
        window.location.href = `${baseUrl}${url}`;
    };

    return (
        <div>
            <main className="sl-main sl-mt-8">
                <div className={"sl-container sl-m-auto sl-my-8"}>

                    <h1 className={`sl-mb-10 sl-text-xl sl-text-gray-900`}>Admin Features</h1>

                    <div className={`sl-row`}>
                        {features.map((feature, index) => (
                            <div className="sl-col-span-3" key={index}>
                                <div
                                    className="sl-font sl-p-8 sl-text-left sl-border sl-border-radius-8 sl-h-54 sl-flex sl-flex-col sl-justify-space-between sl-mb-2">
                                    <div>
                                        <h4 className="sl-mb-2 sl-font-semibold sl-text-gray-900">{feature.name}</h4>
                                        <p className="sl-mb-8">{feature.description}</p>
                                    </div>
                                    <button
                                        className="sl-btn sl-btn-primary sl-width-100 sl-p-2"
                                        onClick={() => handleRedirect(feature.url)}
                                    >
                                        Manage
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </main>
        </div>
    );
};

export default AdminFeatures;
